import Button from '@/shared/Button';
import Div from '@/shared/Div';
import Paragraph from '@/shared/Paragraph';
import React from 'react';
import FormFields from './FormFields';
import Map from '../Map';
import useScreen from '@/hooks/useScreen';
import {
  D365_USER_ID,
  FORMTYPES,
  HEADING_LABELS,
  PROFILE_FIELD_LABELS,
} from '@/constants/profileManagement';
import Cookies from '@/utils/cookie';

function ProfileInfo({ handleEditClick, profileData = {} }: any) {
  const { isDesktop } = useScreen();
  let { firstName, lastName, contacts = [], customerId, editAllowed } = profileData || {};

  const isEcomUser = !Cookies.get(D365_USER_ID);
  const primaryContact: any =
    contacts?.find((contact: any) => contact?.isPrimary && contact?.phone) || {};
  const emailContacts: any = contacts?.filter((contact: any) => contact?.email) || {};
  const secondaryContacts = contacts?.filter(
    (contact: any) => !contact?.isPrimary && contact?.phone,
  );

  const formFieldsData = [
    //Primary Username
    {
      showEditIcon: true,
      onEditClick: () =>
        handleEditClick(FORMTYPES.EDIT_PRIMARY_USER, HEADING_LABELS.EDIT_PRIMARY_USER),
      label: PROFILE_FIELD_LABELS.PRIMARY_USER,
      name: firstName,
      lastName: lastName,
      inputValue: primaryContact?.phone
        ? `${firstName ? `${firstName},` : ''}${primaryContact?.phone}`
        : '',
    },
    // Email Contacts
    ...emailContacts?.map((contact: any, index: number) => {
      const { email, id } = contact || {};
      return {
        showEditIcon: true,
        showDeleteIcon: true,
        onEditClick: () => handleEditClick(FORMTYPES.EDIT_EMAIL, HEADING_LABELS.EDIT_EMAIL, id),
        label: PROFILE_FIELD_LABELS.EMAIL,
        inputValue: email || null,
        contactId: contact?.id,
      };
    }),

    //Secondary Contacts
    ...secondaryContacts?.map((contact: any, index: number) => {
      const { phone, id, name } = contact || {};
      return {
        showEditIcon: true,
        showDeleteIcon: true,
        onEditClick: () =>
          handleEditClick(FORMTYPES.EDIT_SECONDARY_USER, HEADING_LABELS.EDIT_SECONDARY_USER, id),
        label: PROFILE_FIELD_LABELS.SECONDARY_USER,
        inputValue: name ? `${name}, ${phone}` : phone || null,
        contactId: id,
      };
    }),
  ];

  return (
    <Div className="flex flex-col gap-s6 md:max-w-md">
      {isDesktop ? (
        <Div className="flex flex-col gap-s2">
          {firstName ? (
            <Paragraph className="text-h-2">{`Hi ${firstName} ${lastName || ''}`} </Paragraph>
          ) : null}
          {customerId ? (
            <Paragraph className="text-body-lg">{`Customer ID: ${customerId}`}</Paragraph>
          ) : null}
        </Div>
      ) : null}
      {isDesktop ? null : <Paragraph className="text-h-2">Your Profile</Paragraph>}
      <Div className="flex flex-col gap-s3 w-full">
        <Div className="py-s4  border-b flex justify-between items-center">
          <Paragraph className="text-h-4">Contact Details</Paragraph>

          <Div className="flex flex-col">
            {emailContacts.length >= 1 || isEcomUser || !editAllowed ? null : (
              <Button
                theme="link"
                className="text-button-small"
                onClick={() => handleEditClick(FORMTYPES.EDIT_EMAIL, HEADING_LABELS.ADD_EMAIL)}
              >
                + Add Email
              </Button>
            )}
            {secondaryContacts.length >= 1 || isEcomUser || !editAllowed ? null : (
              <Button
                theme="link"
                className="text-button-small"
                onClick={() =>
                  handleEditClick(FORMTYPES.EDIT_SECONDARY_USER, HEADING_LABELS.ADD_SECONDARY_USER)
                }
              >
                + Add secondary user
              </Button>
            )}
          </Div>
        </Div>
        <Map
          list={formFieldsData}
          render={(props, index) => (
            <FormFields key={index} {...props} isEditAllowed={editAllowed} />
          )}
        />
      </Div>
    </Div>
  );
}

export default ProfileInfo;
